import './App.css';
import React from 'react';
import MainLayout from './Containers/MainLayout';
import { AuthContextProvider } from './Context/authContext';
import ThemeProvider from './Utils/themeProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from './Utils/i18next/i18n.js';
import 'react-calendar/dist/Calendar.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-phone-input-2/lib/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import { AppContextProvider } from './Context/appContext';
import { FormContextProvider } from './Context/formContext';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import {
  useLocation,
  useNavigate,
  createRoutesFromChildren,
  matchRoutes,
  useSearchParams,
  NavLink,
  useNavigationType
} from 'react-router-dom';
import { SENTRY_DSN, REACT_APP_ENVIRONMENT } from "../src/Constants/constant.js"
import { ErrorFallback } from './Utils/ErrorBoundary.js';

// import { Worker } from '@react-pdf-viewer/core';
const sentryDSN = SENTRY_DSN
// const isLocalhost = window.location.hostname === 'localhost';
// console.log("window.location.hostname", window.location.hostname);

// import { Worker } from '@react-pdf-viewer/core';

function App() {
  // console.log("liveurl",LIVE_URL)
  try {
    Sentry.init({
      dsn: sentryDSN,
      environment: REACT_APP_ENVIRONMENT,
      integrations: [
        Sentry.browserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigate,
          createRoutesFromChildren,
          matchRoutes,
          useSearchParams,
          NavLink,
        }),
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // beforeSend: (event) => {
      //   console.log("event", event);
        // if (REACT_APP_ENVIRONMENT !== "UAT") {
        //   // Set the correct URL in the event data
        //   event.request.url = LIVE_URL + event.request.url;
        // }
        // return event;

      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [/^https:\/\/sp-jain-new-stg-admissionportal\.ken42\.com\//],

      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

  }
  catch (err) {
    console.error('Sentry initatization error', err);
  }
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => {
        return (
          <ErrorFallback
            error={error.message}
            resetErrorBoundary={() => {
              resetError();
            }}
          />
        );
      }}
    >
    <BrowserRouter>
      {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.min.js"> */}
      <AppContextProvider>
        <FormContextProvider>
          <AuthContextProvider>
            <ThemeProvider>
              <I18nextProvider i18n={i18n}>
                <div className="App">
                  <MainLayout />
                </div>
              </I18nextProvider>
            </ThemeProvider>
          </AuthContextProvider>
        </FormContextProvider>
      </AppContextProvider>
      {/* </Worker> */}
    </BrowserRouter>
    </Sentry.ErrorBoundary>
    
  );
}

export default App;
